
import { fitHtmlText } from '../../../assets/js/modules/_fit-html-text';

let interval = false;
const offset = 10;
let prevScrollLeft = 0;

function ready() {
	document.querySelectorAll('.stats-slide-activated').forEach( (node) => {

		const controls = {
			prev: node.querySelector('.stats-nav > .prev-slide'),
			next: node.querySelector('.stats-nav > .next-slide'),
			list: node.querySelector('.statistics__items'),
			listPadding: 75,
			parent: node,
			navActive: 'stats-nav--active',
			navs: node.querySelectorAll('.stats-nav button'),
		};

		// controls.prev.addEventListener('click', () => backskip(controls));
		// controls.next.addEventListener('click', () => skip(controls));
		controls.prev.addEventListener('touchstart', () => reverse( controls));
		controls.prev.addEventListener('touchend', () => stop(controls));
		controls.prev.addEventListener('touchcancel', () => stop(controls));
		controls.next.addEventListener('touchstart', () => forward(controls));
		controls.next.addEventListener('touchend', () => stop(controls));
		controls.next.addEventListener('touchcancel', () => stop(controls));

		controls.prev.addEventListener('mousedown', () => reverse(controls));
 		controls.prev.addEventListener('mouseup', () => stop(controls));
		controls.next.addEventListener('mousedown', () => forward(controls));
 		controls.next.addEventListener('mouseup', () => stop(controls));

		maybeDisable(controls);
		maybeHideNav(controls);
		addEventListener('resize', () => maybeHideNav(controls));
 	});
}

const reverse = ( controls ) => {
	stop(controls);
	const { list } = controls;

	interval = setInterval( () => {
		list.scrollLeft -= 10;
	}, 8);
	maybeDisable(controls);
}

const forward = ( controls ) => {
	const { list } = controls;

	interval = setInterval( () => {
		list.scrollLeft += 10;
	}, 8);

	maybeDisable(controls);
}

const stop = (controls) => {
	if (interval) {
		clearInterval( interval );
	}
	maybeDisable(controls);
}

const maybeHideNav = (controls) => {
	const { listPadding, list, parent, navs } = controls;
	let widthOfChildren = 0;

	let wideWidthStr = getComputedStyle(document.documentElement).getPropertyValue('--wdg-wide-width');
	let widePx;

	if (wideWidthStr) {
		// dissect clamp
		if (wideWidthStr.includes('clamp')) {
			wideWidthStr = wideWidthStr.split(', ').map((str) => str.match(/[.0-9]/g).join(''));
			widePx = wideWidthStr[1] * 0.01 * window.innerWidth;

			if (widePx > wideWidthStr[2]) {
				widePx = wideWidthStr[2];
			}
			if (widePx > parent.offsetWidth) {
				widePx = parent.offsetWidth;
			}
		}

	} else {
		widePx = parent.offsetWidth;
	}

	[...list.children].forEach((li) => {
		widthOfChildren += li.offsetWidth;
	});

	if (widthOfChildren > widePx ) {
		[ ...navs].forEach((nav) => nav.classList.add(controls.navActive));
	} else {
		[ ...navs].forEach((nav) => nav.classList.remove(controls.navActive));
	}
}

const maybeDisable = (controls) => {
	const { list, next, prev } = controls;
	const { scrollLeft } = list;

	const maxScrollLeft = list.scrollWidth - list.clientWidth;

	if ((maxScrollLeft - scrollLeft ) < 150) {
		next.disabled = true;
	}

	// reached beginning of list
	if ( list.scrollLeft <= 30 ) {
		prev.disabled = true;
		next.disabled = false;
	} else {
		prev.disabled = false;
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
 	document.querySelectorAll( '.statistics__stat--auto-font-size' ).forEach( (el) => {
		fitHtmlText(el, { fittedClass: 'statistics__stat--auto-font-size--fitted' });
	});

	document.querySelectorAll( '.statistics' ).forEach( (stat) => {
		const item = stat.getElementsByClassName('statistics__items');
		const length = item[0].children.length
		if (length <= 4) {
			return;
		}
		stat.classList.add('stats-slide-activated');
		stat.insertAdjacentHTML(
			'beforeend',
			`<div class="stats-nav">
				<button class="prev-slide">
					<svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g id="icon / arrow">
					<circle id="Ellipse 4609" cx="37.9223" cy="37.9223" r="36.8231" stroke="currentColor" stroke-width="2.1984"/>
					<path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M21.6029 38.6931C21.1819 38.2653 21.1819 37.5789 21.6029 37.1511L35.9223 22.6007C36.3481 22.168 37.0441 22.1624 37.4768 22.5882C37.9095 23.014 37.915 23.71 37.4892 24.1427L23.9285 37.9221L37.4892 51.7015C37.915 52.1342 37.9095 52.8301 37.4768 53.256C37.0441 53.6818 36.3481 53.6762 35.9223 53.2435L21.6029 38.6931ZM28.7926 36.8229L54.3094 36.8229C54.9164 36.8229 55.4086 37.315 55.4086 37.9221C55.4086 38.5291 54.9164 39.0213 54.3094 39.0213H28.7926V36.8229Z" fill="currentColor"/>
					</g>
					</svg>

				</button>
				<button class="next-slide">
					<svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g id="Group 15758">
					<circle id="Ellipse 4609" cx="37.9223" cy="37.9223" r="36.8231" transform="matrix(-1 0 0 1 76 0)" stroke="currentColor" stroke-width="2.1984"/>
					<path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M54.3962 38.6931C54.8172 38.2653 54.8172 37.5789 54.3962 37.1511L40.0767 22.6007C39.6509 22.168 38.9549 22.1624 38.5222 22.5882C38.0896 23.014 38.084 23.71 38.5098 24.1427L52.0705 37.9221L38.5098 51.7015C38.084 52.1342 38.0896 52.8301 38.5222 53.256C38.9549 53.6818 39.6509 53.6762 40.0767 53.2435L54.3962 38.6931ZM47.2065 36.8229L21.6897 36.8229C21.0826 36.8229 20.5905 37.315 20.5905 37.9221C20.5905 38.5291 21.0826 39.0213 21.6897 39.0213H47.2065V36.8229Z" fill="currentColor"/>
					</g>
					</svg>
				</button>
			</div>`
		);
	})

	ready();
});

